/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0",
    versionName: "local 0.6.0",
    versionChannel: "local",
    buildDate: "2026-09-17T14:35:09.806Z",
    commitHash: "22f6c2ab59f3e031c8f61f19da8f47eb860a374c",
};
